module.exports = __webpack_public_path__ + "img/india.10356fbc.svg";